export default "__VITE_ASSET__e7ebe447__"